import { render, staticRenderFns } from "./DisabledStaffList.vue?vue&type=template&id=3825675c&scoped=true&"
import script from "./DisabledStaffList.vue?vue&type=script&lang=js&"
export * from "./DisabledStaffList.vue?vue&type=script&lang=js&"
import style0 from "./DisabledStaffList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DisabledStaffList.vue?vue&type=style&index=1&id=3825675c&lang=scss&scoped=true&"
import style2 from "./DisabledStaffList.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3825675c",
  null
  
)

export default component.exports